// test2499
(2499 && 0);
